import { Action, Role, VoiceChatMessage } from "@/lib/messaging";
import { useEffect, useState } from "react";

import BaseChatComponent from "@/components/modes/base-chat";
import { CountdownTimer } from "@/components/pages/voicechat/countdown-timer";
import { Modes } from "@/lib/modes";
import useMessaging from "@/hooks/messaging";

interface ImprotestProps {
  messages: VoiceChatMessage[];
  resetSignal: boolean;
  setAudioPlaying: (isPlaying: boolean) => void;
  appendMessage: (message: VoiceChatMessage) => void;
  sendWsMessage: (message: VoiceChatMessage) => void;
  restartMode: () => void;
}

export default function ImprotestComponent({
  messages,
  resetSignal,
  setAudioPlaying,
  sendWsMessage,
  restartMode,
}: ImprotestProps) {
  const { buildMessage } = useMessaging();

  const [countDownStarted, setCountDownStarted] = useState(false);
  const [improvWordsList, setimprovWordsList] = useState<string[]>([]);
  const [endCycle, setEndCycle] = useState<boolean>(false);
  const [improvWordIndex, setImprovWordIndex] = useState(0);
  const [resetToggle, setResetToggle] = useState(false);

  useEffect(() => {
    setResetToggle((prev) => !prev);
    setCountDownStarted(false);
    setimprovWordsList([]);
    setEndCycle(false);
    setImprovWordIndex(0);
  }, [resetSignal]);

  useEffect(() => {
    console.log("Improtest messages: ", messages);
    if (!messages || messages.length == 0) return;

    // First message should be improtest words list
    if (
      messages.length == 1 &&
      messages[0].action === Action.Setup &&
      messages[0].message
    ) {
      const wordsString = messages[0].message;
      console.log("improv words: ", wordsString);
      setimprovWordsList(wordsString.split(",").map((word) => word.trim()));
      return;
    }
  }, [messages]);

  const nextImprovWord = () => {
    if (improvWordsList.length === 0) return;
    const nextIndex = improvWordIndex + 1;
    if (nextIndex == improvWordsList.length) {
      setEndCycle(true);
      return;
    }
    setImprovWordIndex(nextIndex);
  };

  // Send events to backend to sync conversation events
  useEffect(() => {
    if (endCycle) {
      // If next index outside of range, then the game is complete
      setTimeout(() => {
        // Add a small delay so user last message can be processed
        const message = buildMessage(
          Role.System,
          Action.End,
          Modes.ImproTest.modeStr,
        );
        sendWsMessage(message);
      }, 1500);

      return;
    }

    const newWord = improvWordsList[improvWordIndex];
    if (countDownStarted && newWord) {
      const message = buildMessage(
        Role.Assistant,
        Action.Message,
        Modes.ImproTest.modeStr,
      );
      message.clientTranscription = newWord;
      sendWsMessage(message);
    }
  }, [countDownStarted, improvWordIndex, endCycle]);

  return (
    <div className="flex flex-col overflow-none h-full pt-10">
      <CountdownTimer
        resetSignal={resetToggle}
        startDelay={5}
        endCycle={endCycle}
        onStarted={() => setCountDownStarted(true)}
        onCycleComplete={nextImprovWord}
        cycleDuration={10}
      />
      <h2 className="text-2xl font-bold mb-4 text-center">
        {!endCycle && countDownStarted && improvWordsList.length > 0
          ? improvWordsList[improvWordIndex]
          : ""}
      </h2>
      <div className="flex-1 min-h-0">
        <BaseChatComponent
          messages={messages}
          setAudioPlaying={setAudioPlaying}
          isAutoPlay={false}
          restartMode={restartMode}
        />
      </div>
    </div>
  );
}
